module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA9ElEQVRIS+3W0Q2CMBAG4P/QKH1yBlbSAaRvoi+OgCP4xKsLSDqCIziCbsCTPNUzoBhNVCg0JCZlgPt617srhJ4/6tlDY3Ca5CEBcwYOaSQ2bQ/aGJwlOT8R5qPmoVSr0dEUbgcCYOaMPC/eL/ytCdoafMlWaSGkkpQ1gbuDVbYYyP1yrOpQK2CBFCW+ChHUZWoNLFANBCoSp19ZGoN879UzgPfAVI5LbLWkBUYEMLBpEvwTbpxheV8O/HGRrqTP4rwub9c0VjeNm0Oru7QK5rr0X7v0kgE0eYyFTCOxq2uQTu/hNMljAq8BHLQvwrp/l2+HuQGwv7QdllnK5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/editSourceIcon/up-hv.png
// module id = DHtO
// module chunks = 96